<div class="dish-picture" [class.dish-picture__default]="selectedImgSrc === imgDefaultSrc">
  <input
    #uploadFile
    style="display: none;"
    type="file"
    (change)="changeImg($event)"
  >

  <button
    [disabled]="!allowOverrides"
    type="button"
    (click)="uploadFile.click()"
    class="dish-imgbtn"
  >
  <span class="dish-img-wrapper">
    <img [src]="selectedImgSrc" alt="" class="dish-img">
  </span>
  </button>

  <div class="dish-picture-buttons" *ngIf="allowOverrides">
    <div
      class="dish-picture__restore"
      *ngIf="isShowRestore()"
      (click)="restoreImg()"
    >
      <mat-icon matTooltip="{{originalUrl}}" mat-icon-button>restore</mat-icon>
    </div>
    <div
      class="dish-picture__delete"
      *ngIf="selectedImgSrc !== imgDefaultSrc"
      (click)="deleteDishImg()"
    >
      <mat-icon>delete_outline</mat-icon>
    </div>
  </div>
</div>
